import { REPORTS_PATH } from '../../constants'
import getInstanceIdsReduxSelector from '../../../../redux/selectors/get-instance-ids'

export const getReportIdsSelector = getInstanceIdsReduxSelector(
  REPORTS_PATH.DATA,
  REPORTS_PATH.ALL_DATA
)
